<template>
  <div class="home-container">
    <div class="decorate left top"></div>
    <div class="decorate left bottom"></div>
    <div class="decorate right top"></div>
    <div class="decorate right bottom"></div>
    <div class="home-navbar">
      <div class="switch-box">
        <div class="switch" type="text" @click="openHome">
          {{ $t("B2B.header9") }}
        </div>
      </div>
      <div class="user-box">
        <div class="logout" type="text" @click="gotoUserPage" v-if="isLogin()">
          <span v-if="loginType() == 'C'">{{ $t("B2B.header6") }}</span>
          <span v-else-if="loginType() == 'SU'">{{ $t("B2B.header5") }}</span>
          <span v-else>{{ $t("B2B.header6") }}</span>
        </div>
        <div class="login" type="text" @click="gotoLogin" v-else>
          {{ $t("B2B.header7") }}
        </div>
      </div>
      <div class="language-box">
        <div class="text" @click="handleSetLanguage('en')" v-if="getLang() === 'zh'">
          English
        </div>
        <div class="text" @click="handleSetLanguage('zh')" v-else>中文</div>
      </div>
    </div>
    <div class="home-header">
      <div class="logo" @click="openHome">
        <img src="../../assets/img/logo.png" />
      </div>
      <div class="searchBox">
        <div class="searchInfo">
          <input
            class="searchInoput"
            :placeholder="$t('navBar.search')"
            v-model="searchText"
            @keyup.enter="gotoSearch"
          />
          <div class="searchLogo" @click="gotoSearch">
            <img class="searchLogoIcon" src="~assets/img/store/icon_home_search@2x.png" />
          </div>
        </div>
      </div>
      <div class="menus">
        <div class="download">
          <div class="download-label">{{ $t("B2C.download") }}</div>
          <div class="qrCode" style="margin-right: 30px" @click="onDownload('ios')">
            <img src="~assets/img/ios-qr-code.png" />
            <div class="qrCode-text">{{ $t("B2C.ios") }}</div>
          </div>
          <div class="qrCode" @click="onDownload('android')">
            <img src="~assets/img/android-qr-code.png" />
            <div class="qrCode-text">{{ $t("B2C.android") }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="sec-break"></div>
    <div class="box">
      <div class="box-left">
        <div class="attItems">
          <div @click="gotoHotSales" class="attBox">
            <div class="image">
              <img src="~assets/img/hotSales.png" />
            </div>
            <div class="name">{{ $t("B2C.hotSales") }}</div>
          </div>
          <div @click="gotoDiscount" class="attBox">
            <div class="image">
              <img src="~assets/img/discount.png" />
            </div>
            <div class="name">{{ $t("B2C.discountProducts") }}</div>
          </div>
          <div @click="gotoBrand" class="attBox">
            <div class="image">
              <img src="~assets/img/brand.png" />
            </div>
            <div class="name">{{ $t("B2C.brandProducts") }}</div>
          </div>
        </div>
        <div class="attItems" style="margin-top: 30px">
          <div @click="gotoAttestation" class="attBox">
            <div class="image">
              <img src="~assets/img/attestation.png" />
            </div>
            <div class="name">{{ $t("B2C.attestationProducts") }}</div>
          </div>
          <div class="attBox" style="width: 40%">
            <el-select
              class="m-b-20"
              v-model="atid"
              :placeholder="$t('B2C.select')"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in attestationTypeList"
                :key="item.ATId"
                :label="item.AttestationName"
                :value="item.ATId"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="hotSalesItems" v-if="hotListProduct && hotListProduct.length > 0">
          <div
            v-for="(item, index) in hotListProduct"
            @click="toDetail(item.LinkStu, item.OtherLinkStu)"
            :key="index"
            class="hotSalesBox"
          >
            <div class="image">
              <el-image :src="item.ImgUrl" fit="contain"></el-image>
            </div>
            <div class="name">{{ item.ClassName }}</div>
          </div>
        </div>
      </div>
      <div class="box-center">
        <div class="slides" v-if="listViewAdverts && listViewAdverts.length > 0">
          <el-carousel height="300px">
            <el-carousel-item
              v-for="(item, index) of listViewAdverts"
              @click.native="toDetail(item.LinkStu, item.OtherLinkStu)"
              :key="index"
            >
              <el-image :src="item.ImgUrl" fit="cover"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="video">
          <video-tool :listVideoAdverts="listVideoAdverts" />
        </div>
      </div>
      <div class="box-right">
        <div class="userBox" @click="gotoUserPage" v-if="isLogin() && loginType() == 'C'">
          <div class="userImgBox">
            <img
              class="ImgIcon"
              :src="cUserInfo && getuserImgUrl(cUserInfo.UserHeadPhoto)"
              :onerror="errorImg"
            />
          </div>
          <div class="name">
            {{ cUserInfo.NickName == "" ? cUserInfo.UserName : cUserInfo.NickName }}
          </div>
          <div class="email">{{ cUserInfo.Email }}</div>
          <div class="check">
            <span class="label">{{ $t("B2C.registerShop") }} : </span>
            <span
              v-if="cUserInfo.IsShopSubmit == 1 && cUserInfo.IsShopCheck == 1"
              class="greenBox"
              >{{ $t("B2C.shopState1") }}</span
            >
            <span
              v-if="cUserInfo.IsShopSubmit == 1 && cUserInfo.IsShopCheck == 2"
              class="redBox"
              >{{ $t("B2C.shopState2") }}</span
            >
            <span
              v-if="cUserInfo.IsShopCheck == 0 && cUserInfo.IsShopSubmit == 0"
              class="redBox"
              >{{ $t("B2C.shopState3") }}</span
            >
            <span
              v-if="cUserInfo.IsShopCheck == 0 && cUserInfo.IsShopSubmit == 1"
              class="yellowBox"
              >{{ $t("B2C.shopState4") }}</span
            >
          </div>
        </div>
        <div
          class="userBox"
          @click="gotoUserPage"
          v-else-if="isLogin() && loginType() == 'SU'"
        >
          <div class="userImgBox">
            <img
              class="ImgIcon"
              :src="supplierInfo && getuserImgUrl(supplierInfo.HeadPhoto)"
              :onerror="errorImg"
              v-if="supplierInfo.HeadPhoto"
            />
            <img class="ImgIcon" src="@/assets/img/user/img_logo@2x.png" v-else />
          </div>
          <div class="name">
            {{
              supplierInfo.CompanyName == "" ? auth.userName : supplierInfo.CompanyName
            }}
          </div>
          <div class="check">
            <span class="label">{{ $t("B2C.supplierAuth") }} : </span>
            <span v-if="supplierInfo.IsSubmit">
              <span v-if="supplierInfo.IsChecked == 1" class="greenBox">{{
                $t("B2C.shopState1")
              }}</span>
              <span v-if="supplierInfo.IsChecked == -1" class="redBox">{{
                $t("B2C.shopState2")
              }}</span>
              <span v-if="supplierInfo.IsChecked == 0" class="yellowBox">{{
                $t("B2C.shopState4")
              }}</span>
            </span>
            <span v-else>
              <span class="redBox">{{ $t("B2C.shopState3") }}</span>
            </span>
          </div>
        </div>
        <div class="userBox" @click="gotoLogin" v-else>
          <div class="userImgBox">
            <img class="ImgIcon" src="@/assets/img/icon_personal.png" />
          </div>
          <div class="name">{{ $t("B2C.login") }}</div>
        </div>
        <div class="msgBox" @click="gotoMessage" v-if="loginType() == 'C'">
          <div class="msg-title">
            <i class="el-icon-bell"></i>
            <span>{{ $t("B2C.message") }}</span>
          </div>
          <div class="msg-content">
            <div
              class="text"
              v-html="msgInfo.Content && strReplace(msgInfo.Content)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <menu-list
      :listHotClass="listHotClass"
      :listHotProducts="listHotProducts"
      @loadMenuProduct="loadCategory"
    />

    <shopCart></shopCart>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VideoTool from "./components/videoTool";
import MenuList from "./components/menuList";
export default {
  name: "Home",
  components: {
    MenuList,
    VideoTool,
  },
  data() {
    return {
      atid: "",
      attestationTypeList: [],
      pageIndex: 1,
      totalCount: 1,
      listViewAdverts: [],
      listVideoAdverts: [],
      listHotClass: [],
      listHotProducts: {
        product: [],
        totalCount: 1,
      },
      msgInfo: {},
      hotListProduct: [],
      allListProduct: [],
      classLists: [],
      className: "",
      cateIndex: 1,
      cateSize: 50,
      auth: {},
      searchText: "",
      errorImg: 'this.src="' + require("@/assets/img/user/img_logo@2x.png") + '"',
    };
  },
  computed: {
    ...mapState({
      cUserInfo: (state) => state.cUser.cUserInfo,
      supplierInfo: (state) => state.supplier.supplierInfo,
    }),
  },
  mounted() {
    this.auth = JSON.parse(localStorage.getItem("auth")) || {};
    // if (this.isLogin()) {
    //   if (this.loginType() == "C") {
    //     this.getCUser().then(res => {
    //       this.cUserInfo = res.data;
    //     });
    //   } else {
    //     this.getSupplier().then(res => {
    //       this.supplierInfo = res.data;
    //     });
    //   }
    // }
  },
  created() {
    this.loadIndex();
    //this.loadProductClass();
  },
  methods: {
    ...mapActions(["getCUser", "getSupplier", "setLanguage"]),
    toDetail(productNumber, shopId) {
      var param = {};
      if (shopId) {
        param = {
          path: "/store",
          query: { ShopId: shopId },
        };
      }
      if (productNumber && shopId) {
        param = {
          path: "/details",
          query: { ProductNumber: productNumber, ShopId: shopId },
        };
      }
      let routeUrl = this.$router.resolve(param);
      window.open(routeUrl.href, "_blank");
    },
    getuserImgUrl(userImgUrl) {
      return this.$api.formatImageUrl(userImgUrl);
    },
    loginType() {
      return this.auth.type;
    },
    isLogin() {
      return this.$store.getters.isLogging;
    },
    getLang() {
      return this.$store.getters.getLanguage;
    },
    gotoUserPage() {
      if (this.loginType() == "C") {
        this.$router.push("/cUser");
      } else {
        if (this.supplierInfo.B2bMode == 1) {
          this.$router.push("/public");
        } else if (this.supplierInfo.B2b2cMode == 1) {
          this.$router.push("/supplier");
        } else {
          this.$router.push("/activate");
        }
      }
    },
    gotoLogin() {
      this.$router.push("/login");
    },
    gotoMessage() {
      this.$router.push("/messageList");
    },
    gotoSearch() {
      let routeUrl = this.$router.resolve({
        path: "/search",
        query: { SearchText: this.searchText },
      });
      window.open(routeUrl.href, "_blank");
    },
    gotoDiscount() {
      let routeUrl = this.$router.resolve({
        path: "/search",
        query: { title: this.$t("B2C.discountProducts"), IsCouponProduct: 1 },
      });
      window.open(routeUrl.href, "_blank");
    },
    gotoBrand() {
      let routeUrl = this.$router.resolve({
        path: "/search",
        query: { title: this.$t("B2C.brandProducts"), IsBrandProduct: 1 },
      });
      window.open(routeUrl.href, "_blank");
    },
    gotoAttestation() {
      let routeUrl = this.$router.resolve({
        path: "/search",
        query: {
          title: this.$t("B2C.attestationProducts"),
          IsAttestationProduct: 1,
          ATId: this.atid,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    gotoHotSales() {
      let routeUrl = this.$router.resolve({
        path: "/search",
        query: { title: this.$t("B2C.hotSales"), Order: 1 },
      });
      window.open(routeUrl.href, "_blank");
    },
    openHome() {
      var url = "";
      if (process.env.NODE_ENV === "development") {
        url = " http://localhost:3001";
      } else {
        url = "https://www.vancheen.com";
      }
      window.open(url, "_self");
    },
    onDownload(platform) {
      if (platform == "ios") {
        window.open("https://apps.apple.com/app/vancheen/id6723865168");
      } else {
        window.open("https://play.google.com/store/apps/details?id=com.vancheen.client");
      }
    },
    loadIndex() {
      let param = {};
      this.$api.index
        .loadAppIndex(param)
        .then((res) => {
          const data = res.data;
          this.listViewAdverts = data.ListViewAdverts;
          this.listVideoAdverts = data.ListVideoAdverts;
          this.msgInfo = data.Msg;
          this.hotListProduct = data.HotListProduct;
          this.allListProduct = data.AllListProduct.BannerListProduct;

          this.listHotClass = data.ListHotClass;
          if (this.listHotClass && this.listHotClass.length > 0) {
            this.className =
              this.listHotClass[0].HotClassId == -999
                ? ""
                : this.listHotClass[0].ClassName;
            this.loadSearchProductByPage();
          }
          this.getAttestationTypeList();
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    loadProductClass() {
      let param = {};
      this.$api.index
        .loadProductClass(param)
        .then((res) => {
          this.classLists = res.data;
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    getAttestationTypeList() {
      let param = {};
      this.$api.product
        .getAttestationTypeList(param)
        .then((res) => {
          this.attestationTypeList = res.data;
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    loadCategory(data) {
      this.className = data.className;
      this.cateIndex = data.pageIndex;
      this.cateSize = data.pageSize;
      this.loadSearchProductByPage();
    },
    loadSearchProductByPage() {
      let param = {
        ClassName: this.className,
        PageIndex: this.cateIndex,
        PageSize: this.cateSize,
        order: 1,
      };
      this.$api.search
        .loadSearchProductByPage(param)
        .then((res) => {
          const data = res.data;
          this.listHotProducts.product = data;
          this.listHotProducts.totalCount = res.meta.total;
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    strReplace(value) {
      return value.replace(/\\n/gm, "<br/>");
    },
    handleSetLanguage(lang) {
      this.setLanguage(lang);
      location.reload();
      if (lang == "en") {
        this.$message({
          message: "Switch Language Success",
          type: "success",
        });
      } else {
        this.$message({
          message: "切换语言成功",
          type: "success",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  position: relative;
  .decorate {
    position: absolute;
    width: 300px;
    height: 300px;
    background-size: cover;
    z-index: -1;
    &.left {
      left: 0;

      &.top {
        background-image: url("../../assets/img/welcome_left_top.png");
      }

      &.bottom {
        background-image: url("../../assets/img/welcome_left_bottom.png");
      }
    }

    &.right {
      right: 0;

      &.top {
        background-image: url("../../assets/img/welcome_right_top.png");
      }

      &.bottom {
        background-image: url("../../assets/img/welcome_right_bottom.png");
      }
    }

    &.top {
      top: 0;
    }

    &.bottom {
      bottom: 0;
    }
  }
  .sec-break {
    position: relative;
    width: 90%;
    margin: 0 auto;
    height: 2px;
    background: #e5e5e5;
  }
  .home-navbar {
    text-align: right;
    padding: 5px 50px 5px 0px;
    .switch-box {
      display: inline-block;
      margin-right: 20px;
      padding-right: 20px;
      border-right: 1px solid #666;
      vertical-align: middle;
      .switch {
        font-size: 14px;
        font-weight: 300;
        color: #333;
        cursor: pointer;
      }
    }
    .user-box {
      display: inline-block;
      margin-right: 20px;
      padding-right: 20px;
      border-right: 1px solid #666;
      vertical-align: middle;
      .login {
        font-size: 14px;
        font-weight: 300;
        color: #333;
        cursor: pointer;
      }
      .logout {
        font-size: 14px;
        font-weight: 300;
        color: #333;
        cursor: pointer;
      }
    }
    .language-box {
      display: inline-block;
      vertical-align: middle;
      .text {
        font-size: 14px;
        font-weight: 300;
        color: #333;
        cursor: pointer;
      }
    }
  }
  .home-header {
    padding-top: 2%;
    padding-bottom: 2%;
    .searchBox {
      width: 60%;
      display: inline-block;
      text-align: center;
      vertical-align: middle;
      .searchInfo {
        margin: 0 auto;
        width: 80%;
        padding: 8px 20px;
        border: 3px solid #01aaa3;
        position: relative;
        border-radius: 100px;
        .searchInoput {
          outline: none;
          padding: 0;
          width: 90%;
          border: none;
          background-color: #ffffff;
          font-size: 14px;
          color: #a7a7a7;
          vertical-align: middle;
        }
        .searchLogo {
          margin: 0;
          padding: 0;
          width: 10%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
          cursor: pointer;
          .searchLogoIcon {
            width: 20px;
            height: 20px;
            object-fit: cover;
            -webkit-object-fit: cover;
            // background-color: #434343;
          }
        }
      }
    }
    .logo {
      width: 20%;
      display: inline-block;
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 100px;
        height: 100px;
      }
    }
    .menus {
      width: 20%;
      display: inline-block;
      text-align: center;
      vertical-align: middle;
      .download {
        .download-label {
          font-weight: bold;
          font-size: 18px;
          color: #01aaa3;
          margin-bottom: 12px;
        }
        .qrCode {
          display: inline-block;
          text-align: center;
          cursor: pointer;
          img {
            width: 80px;
            height: 80px;
          }
          .qrCode-text {
            font-size: 14px;
            color: #999;
          }
        }
      }
    }
  }
  .box {
    min-height: 500px;
    margin: auto;
    text-align: center;
    padding-top: 3%;
    .box-left {
      width: 30%;
      display: inline-block;
      text-align: center;
      vertical-align: top;
      .attItems {
        width: 100%;
        display: inline-block;
        .attBox {
          padding: 30px 30px 0px 30px;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
          .image {
            width: 50px;
            height: 50px;
            margin: auto;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .name {
            width: 100%;
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }
      .hotSalesItems {
        padding-top: 60px;
        padding-bottom: 30px;
        display: inline-block;
        .hotSalesBox {
          padding: 0px 15px 0px 15px;
          display: inline-block;
          cursor: pointer;
          .image {
            width: 80px;
            height: 80px;
            border: 2px solid #01aaa3;
            border-radius: 10px;
            margin: auto;
            overflow: hidden;
            .el-image {
              border-radius: 10px;
              width: 100%;
              height: 100%;
            }
          }
          .name {
            width: 100%;
            margin-top: 10px;
            font-size: 12px;
          }
        }
      }
    }
    .box-center {
      width: 30%;
      height: 100%;
      display: inline-block;
      vertical-align: middle;
      .slides {
        width: 100%;
        display: inline-block;
        margin-bottom: 5%;
        background: #fff;
        border-radius: 10px;
        cursor: pointer;
        .el-image {
          width: 100%;
          height: 100%;
        }
        .el-carousel {
          border-radius: 10px;
        }
        .el-carousel__item {
          background-color: transparent;
        }
        ::v-deep .el-carousel__indicators {
          width: 100%;
        }
        ::v-deep .el-carousel__button {
          background-color: #01aaa3;
          height: 5px;
          border-radius: 5px;
          border: solid 0.01rem #fff;
        }
      }
      .video {
        width: 100%;
        display: inline-block;
      }
    }
    .box-right {
      width: 15%;
      margin-left: 3%;
      margin-right: 12%;
      display: inline-block;
      vertical-align: top;
      text-align: center;
      .userBox {
        margin-top: 20%;
        font-size: 14px;
        .userImgBox {
          .ImgIcon {
            width: 80px;
            height: 80px;
            border-radius: 100%;
            object-fit: cover;
            box-shadow: 0 0 5px 0 #25b9ff;
            -webkit-box-shadow: 0 0 5px 0 #25b9ff;
            cursor: pointer;
          }
        }
        .name {
          margin-top: 20px;
        }
        .email {
          margin-top: 20px;
        }
        .check {
          margin-top: 20px;
          .label {
          }
          .greenBox {
            color: #01aaa3;
          }
          .yellowBox {
            color: orange;
          }
          .redBox {
            color: red;
          }
        }
      }
      .msgBox {
        border-radius: 10px;
        margin-top: 10%;
        padding-top: 10%;
        padding-bottom: 10%;
        background: rgb(235, 246, 246);
        box-shadow: 0 0 3px 0 #9b9b9b;
        cursor: pointer;
        .msg-title {
          font-weight: bold;
          font-family: HelveticaNeue LT 97 BlackCn;
          color: #01aaa3;
          span {
            vertical-align: middle;
            margin-right: 30px;
          }
          i {
            font-size: 20px;
            font-weight: bold;
            margin-right: 10px;
            vertical-align: middle;
          }
        }
        .msg-content {
          position: relative;
          .text {
            padding: 20px;
            font-size: 14px;
            border-radius: 10px;
            font-family: Helvetica;
            font-weight: bold;
            line-height: 18px;
          }
        }
      }
    }
  }
}
</style>
